import { request } from './apiClient';
import authStorage from '../utils/authStorage';

export const authService = {
  registerRequestOtp: async (emailId, mobileNo) => {
    return request('/auth/register/request-otp', {
      method: 'POST',
      body: JSON.stringify({ emailId, mobileNo })
    });
  },

  register: async (userData) => {
    return request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({
        ...userData,
        roles: userData.roles || ["USER"]
      }),
    });
  },

  login: async (credentials) => {
    const result = await request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });

    if (result.success && result.data.accessToken) {
      authStorage.setItem('token', result.data.accessToken);
      authStorage.setItem('refreshToken', result.data.refreshToken);
      authStorage.setItem('user', JSON.stringify(result.data.user || { username: credentials.username }));
    }
    return result;
  },

  logout: () => {
    authStorage.removeItem('token');
    authStorage.removeItem('refreshToken');
    authStorage.removeItem('user');
    window.location.href = '/login';
  },

  getUserProfile: async (email) => {
    return request(`/auth/user/${email}`, { method: 'GET' });
  },

  getAdminUsers: async () => {
    return request('/auth/admin/users', { method: 'GET' });
  },

  adminCreateUser: async (userData) => {
    return request('/auth/admin/users', {
      method: 'POST',
      body: JSON.stringify(userData)
    });
  },

  getAdminRoles: async () => {
    return request('/auth/admin/roles', { method: 'GET' });
  },

  updateUserRoles: async (email, roles) => {
    return request(`/auth/admin/users/${email}/roles`, {
      method: 'PUT',
      body: JSON.stringify({ roles })
    });
  },

  updateUserPassword: async (email, password) => {
    return request(`/auth/admin/users/${email}/password`, {
      method: 'PUT',
      body: JSON.stringify({ password })
    });
  },

  forgotPasswordRequest: async (mobileNo) => {
    return request('/auth/forgot-password/request', {
      method: 'POST',
      body: JSON.stringify({ mobileNo })
    });
  },

  forgotPasswordVerify: async (mobileNo, otp, newPassword) => {
    return request('/auth/forgot-password/verify', {
      method: 'POST',
      body: JSON.stringify({ mobileNo, otp, newPassword })
    });
  },

  adminDeleteUser: async (userId) => {
    return request(`/vendor/admin/users/${userId}`, { method: 'DELETE' });
  }
};

export default authService;
